import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { CommandPalette } from './CommandPalette';
import { Spinner, Toaster } from '@/components/ui';

export function AppShell() {
  return (
    <div className="flex h-full overflow-hidden">
      <Sidebar />

      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />

        <main className="flex-1 overflow-y-auto">
          {/* Extra bottom padding keeps the last row clear of a phone's home bar. */}
          <div className="mx-auto w-full max-w-[1600px] p-3 pb-16 sm:p-4 lg:p-6">
            <Suspense
              fallback={
                <div className="flex h-64 items-center justify-center">
                  <Spinner className="h-6 w-6" />
                </div>
              }
            >
              <Outlet />
            </Suspense>
          </div>
        </main>
      </div>

      <CommandPalette />
      <Toaster />
    </div>
  );
}
